import React from "react";
import "../assets/stylesheet/screenLoader.scss";

const HeaderScreenLoader = () => {
  return (
    <div className="headerLoader">
      <div className="loader-circle"></div>
    </div>
  );
};
export default HeaderScreenLoader;
